'use client';

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/atoms/Dialog/Dialog';
import { PassportLogin } from '@/molecules/PassportLogin/PassportLogin';
import { useAuthStore } from '@/stores/auth/auth.store';

/** Authentication-required actions use one Passport entry for existing and new identities. */
export function DialogSignIn() {
  const showSignInDialog = useAuthStore((state) => state.showSignInDialog);
  const setShowSignInDialog = useAuthStore((state) => state.setShowSignInDialog);
  return (
    <Dialog open={showSignInDialog} onOpenChange={setShowSignInDialog}>
      <DialogContent data-testid="dialog-sign-in" className="gap-6">
        <DialogHeader className="gap-2">
          <DialogTitle>{'Log in to Pubky'}</DialogTitle>
          <DialogDescription>{'Continue in Passport to choose an identity or create an account.'}</DialogDescription>
        </DialogHeader>
        <PassportLogin block />
      </DialogContent>
    </Dialog>
  );
}
